import styled from 'styled-components';

import Label from '../Label/Label';
import SimpleModal from '../SimpleModal/SimpleModal';

import { StylingProps } from './ModalWithHeader';

export const Modal = styled(SimpleModal)<StylingProps>`
  &.sc-tag3-simple-modal-h .tag-modal-content.sc-tag3-simple-modal {
    border-top: 4px solid;
    border-top-color: ${({ theme, borderAccent }) =>
      borderAccent || theme.palette.primary.main || '#036D83'};
  }
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(1.2, 2) || '12px 20px'};
  border-bottom: 1px solid ${({ theme }) => theme.palette.colors.fieldBorder || '#DBE0E5'};

  tag3-label, label {
    color: ${({ theme }) => theme.palette.colors.textBodySecondary || '#4E5054'} !important;
    font-size: ${({ theme }) => theme.typography.h5.fontSize || '17px'} !important;
    font-weight: ${({ theme }) => theme.typography.h5.fontWeight || 700} !important;
    }
  }
`;

export const StyledLabel = styled(Label)<{ headerIcon?: JSX.Element }>`
  margin-left: ${({ headerIcon, theme }) => headerIcon && (theme?.spacing?.(1) ?? '10px')};
`;

export const HeaderTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;
